import { type ParsedImage } from "@dotcom/ui";
import styled from "@emotion/styled";
import { Grid, MediaQueries } from "@polestar/component-warehouse-react";

import NewsArticle from "./NewsArticle";

interface NewsArticlesProps {
  readonly newsArticles: Array<{
    id: string;
    slug: string;
    headline: string;
    ingress: string;
    isHighlighted: boolean;
    localizedPublishDate: string;
    thumbnail: {
      imageDesktop?: ParsedImage;
      imageTablet?: ParsedImage;
      imageMobile?: ParsedImage;
    };
  }>;
  readonly locale: string;
  readonly highlightedLabel: string;
  readonly readMoreLabel: string;
}

const StyledGrid = styled(Grid)`
  grid-auto-flow: dense;
  grid-row-gap: 0;

  ${MediaQueries.tablet},
  ${MediaQueries.desktop},
  ${MediaQueries.desktopWide} {
    grid-row-gap: 0;
  }
`;

const NewsArticles = ({
  newsArticles,
  locale,
  highlightedLabel,
  readMoreLabel,
}: NewsArticlesProps) => {
  const isBigByIndex = newsArticles.map(({ isHighlighted }, index) => {
    return isHighlighted || index === 0;
  });
  const isBigByIndexMobile = newsArticles.map(({ isHighlighted }, index) => {
    return isHighlighted || index < 3;
  });

  return (
    <StyledGrid>
      {newsArticles.map(
        (
          {
            id,
            slug,
            headline,
            ingress,
            isHighlighted,
            localizedPublishDate,
            thumbnail,
          },
          index
        ) => {
          return (
            <NewsArticle
              key={id}
              locale={locale}
              slug={slug}
              headline={headline}
              ingress={ingress}
              publishDateLocalised={localizedPublishDate}
              images={thumbnail}
              isHighlighted={isHighlighted}
              isBig={{
                desktop: isBigByIndex[index],
                mobile: isBigByIndexMobile[index],
              }}
              isPreviousArticleBig={{
                desktop: isBigByIndex[index - 1],
                mobile: isBigByIndexMobile[index - 1],
              }}
              highlightedLabel={highlightedLabel}
              readMoreLabel={readMoreLabel}
            />
          );
        }
      )}
    </StyledGrid>
  );
};

export default NewsArticles;
